<template>
    <div class='content'>
        <h3>{{ $t('dashboard.fournisseur.documents.title') }}</h3>
        <div>{{$t('document.fournisseur')}}</div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'WidgetDocument',

});
</script>

<style scoped>
.content {
    background-color: #eaf1f4;
    padding: 10px 30px 30px;
    height: 44vh;
    box-shadow: 5px 4px 5px 0 rgba(0, 0, 0, 0.1);
    border-radius: 20px;
}
@media screen and (max-width: 900px) and (max-height: 700px) {
    .content {
        height: 100% !important;
        padding: unset;
    }
}
@media (max-width: 984px) {
    .content {
        height: 68vh;
    }
}
@media (max-width: 1195px) {
    .content {
        height: 68vh;
    }
}
</style>
